(function(){
var d=document,w=window,root=d.documentElement;
var reduce=w.matchMedia&&w.matchMedia('(prefers-reduced-motion:reduce)').matches;
function $(s,c){return [].slice.call((c||d).querySelectorAll(s))}
var io=null;
function mkIO(){
  if(!('IntersectionObserver' in w))return null;
  return new IntersectionObserver(function(es){
    es.forEach(function(e){
      if(!e.isIntersecting)return;
      var el=e.target;io.unobserve(el);el.classList.add('in');
      setTimeout(function(){el.classList.remove('mrv','in');el.style.removeProperty('--d')},1400);
    });
  },{threshold:0,rootMargin:'0px 0px 18% 0px'});
}
function watch(el){if(io)io.observe(el);else el.classList.add('in')}
var SEL=['main .ey','main .tr>div','main .pcard','main .bgrid .card','main .igg .rt','footer .fcd'];
function init(){
  if(reduce)return;
  root.classList.add('mo');
  if(!io)io=mkIO();
  SEL.forEach(function(s){
    var seen=new Map();
    $(s).forEach(function(el){
      if(el.dataset.mo)return;el.dataset.mo='1';
      var r=el.getBoundingClientRect();
      if(r.top<w.innerHeight*1.1&&r.bottom>-50)return;
      var p=el.parentNode,i=seen.get(p)||0;seen.set(p,i+1);
      el.style.setProperty('--d',(Math.min(i,3)*.06).toFixed(2)+'s');
      el.classList.add('mrv');watch(el);
    });
  });
}
function failsafe(){
  $('.mrv:not(.in)').forEach(function(el){var r=el.getBoundingClientRect();if(r.top<w.innerHeight*1.2)el.classList.add('in')});
}
var bar=null,lastY=0,ticking=false;
function onScroll(){
  ticking=false;
  var y=w.pageYOffset||root.scrollTop||0,b=d.body;
  b.classList.toggle('sc',y>40);
  var dr=d.getElementById('drawer');
  if(y>320&&y>lastY+10&&!(dr&&dr.classList.contains('open')))b.classList.add('hdn');
  else if(y<lastY-6||y<320)b.classList.remove('hdn');
  lastY=y;
  var h=Math.max(1,root.scrollHeight-w.innerHeight);
  if(bar)bar.style.transform='scaleX('+Math.min(1,y/h)+')';
}
function req(){if(!ticking){ticking=true;w.requestAnimationFrame(onScroll)}}
d.addEventListener('click',function(e){
  var b=e.target.closest&&e.target.closest('.btn');if(!b)return;
  var r=b.getBoundingClientRect(),z=Math.max(r.width,r.height)*2,s=d.createElement('span');
  s.className='rp';s.style.cssText='width:'+z+'px;height:'+z+'px;left:'+(e.clientX-r.left-z/2)+'px;top:'+(e.clientY-r.top-z/2)+'px';
  b.appendChild(s);setTimeout(function(){if(s.parentNode)s.parentNode.removeChild(s)},750);
},true);
function magnet(){
  if(!(w.matchMedia&&w.matchMedia('(hover:hover) and (pointer:fine)').matches)||reduce)return;
  $('.hero .btn,.band .btn,.foot .btn').forEach(function(b){
    if(b.dataset.mg)return;b.dataset.mg='1';
    b.addEventListener('mousemove',function(e){var r=b.getBoundingClientRect();b.style.translate=((e.clientX-r.left-r.width/2)*.18).toFixed(1)+'px '+((e.clientY-r.top-r.height/2)*.28).toFixed(1)+'px'});
    b.addEventListener('mouseleave',function(){b.style.translate='0 0'});
  });
}
function fan(){
  var f=d.querySelector('.fs[data-fan]');if(!f||f.dataset.ap||reduce)return;f.dataset.ap='1';
  var nx=f.querySelector('[data-next]'),hov=false,vis=false,t=null;
  if(!nx)return;
  f.addEventListener('mouseenter',function(){hov=true});f.addEventListener('mouseleave',function(){hov=false});
  f.addEventListener('touchstart',function(){hov=true;clearTimeout(t);t=setTimeout(function(){hov=false},9000)},{passive:true});
  if('IntersectionObserver' in w){new IntersectionObserver(function(es){vis=es[0].isIntersecting},{threshold:.35}).observe(f)}else vis=true;
  setInterval(function(){if(vis&&!hov&&!d.hidden)nx.click()},4300);
}
function boot(){
  if(!bar){bar=d.createElement('div');bar.className='spb';d.body.appendChild(bar)}
  init();magnet();fan();onScroll();
  setTimeout(failsafe,1600);setTimeout(failsafe,3500);
}
w.addEventListener('scroll',req,{passive:true});w.addEventListener('resize',req);
if(d.readyState==='loading')d.addEventListener('DOMContentLoaded',boot);else boot();
d.addEventListener('shopify:section:load',function(){init();magnet();fan();setTimeout(failsafe,400)});
})();
